import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import store from '@/store'
import { login, initialize, getUserInfo, loginByExternal, loginByToken } from '@/apis/user'
import { getApplication } from '@/apis/home'
import { getWorkerByDepId, getDeptList } from '@/apis/firm'
import { AppModule } from '@/store/modules/app'
import { getCompanyId, getUserId } from '@/utils/common'
export interface IUserState {
  token: string
  user: any
}

@Module({ dynamic: true, store, name: 'user' })
class User extends VuexModule implements IUserState {
  public isOEM = false
  public token = ''
  public user = {
    name: '',
    nickname: '',
    businessId: 0,
    companyId: 0,
    companyName: '',
    createUser: 0,
    id: 0,
    otherRequirement: '',
    position: '',
    requirement: '',
    userId: 0,
    isSuperAdmin: false
  }

  @Action
  public async login(userInfo: { account: string; password: string }) {
    const data = await login({ account: userInfo.account, password: userInfo.password })
    if (data.code === 200) {
      window.localStorage.setItem('loginForm', JSON.stringify(userInfo))
      let resData = await this.afterLogin(data)
      return resData
    }
  }
  @Action
  public async loginByToken(token) {
    const data = await loginByToken({loginToken: token})
    if (data.code === 200) {
      window.localStorage.setItem('companyId', data.data.companyId || '')
      window.localStorage.setItem('userId', data.data.id)
      this.SET_USER(data.data)
      if (data.data.companyId) {
        this.commonFetchData()
      }
      return data
    } else {
      return this.token
    }
  }
  @Action
  public async loginByExternal(loginInfo) {
    if (window.sessionStorage.getItem('externalType')) {
      // 刷新的情况，数据从localStorage里取
      let res = await getUserInfo()
      if (res.code === 200) {
        return await this.afterLogin({ success: true, code: 200, data: { companyId: getCompanyId(), id: res.data.id, name: res.data.name, headPic: res.data.headPic } })
      }
    } else {
      const data = await loginByExternal(loginInfo)
      if (data.success) {
        window.sessionStorage.setItem('externalType', loginInfo.externalType)
      }
      return await this.afterLogin(data)
    }

  }
  @Action
  public async afterLogin(data) {
    if (data.code === 200) {
      window.localStorage.setItem('companyId', data.data.companyId || '')
      window.localStorage.setItem('userId', data.data.id)
      this.SET_USER(data.data)
      if (data.data.companyId) {
        this.commonFetchData()
      }
    }
    return data
  }
  @Action
  public commonFetchData() {
    this.getApplication()
    this.getWorkers()
    this.getDeptList()
  }
  @Action
  public getDeptList() {
    getDeptList()
      .then((res) => {
        if (res.code === 200) {
          AppModule.ChangeDept(res.data || [])
        }
      })
  }
  @Action
  public getWorkers() {
    getWorkerByDepId({ containDelete: true, blIncludeDepartment: true })
      .then((res) => {
        if (res.code === 200) {
          AppModule.ChangeWorkers(res.data || [])
        }
      })
  }
  @Action
  public getApplication() {
    getApplication({ state: 1 })
      .then((res) => {
        if (res.code === 200) {
          AppModule.ChangeProject(res.data || [])
        }
      })
  }
  @Action
  public async initialize(info: object) {
    try {
      const data = await initialize(info)
      if (data.code === 200) {
        this.SET_USER(data.data)
        window.localStorage.setItem('companyId', data.data.companyId || '')
        this.commonFetchData()
      }
      return data
    } catch (error) {
      return this.token
    }
  }

  @Action
  public async logout() {
    // const data = await logout()
    // if (data.success) {
    //   window.location.href = '/'
    // }
  }
  // oem 相关
  @Action
  public getIsOem() {
    this.SET_OEM(true)
  }
  @Mutation
  private SET_TOKEN(token: string) {
    console.log(1)
  }

  @Mutation
  private SET_USER(data: any) {
    this.user = data
  }
  @Mutation
  private UPDATE_USER(data: any) {
    for (let key in this.user) {
      if (data[key]) {
        this.user[key] = data[key]
      }
    }
    if (data.nickname) {
      this.user.name = data.nickname
    }
    // window.sessionStorage.setItem('loginForm', JSON.stringify(this.user))
  }
  // oem相关
  @Mutation
  private SET_OEM(data: any) {
    this.isOEM = data
  }
  get oem() {
    return this.isOEM;
  }
}

export const UserModule = getModule(User)
